import { render, staticRenderFns } from "./EditReceiverDelivery.vue?vue&type=template&id=5185bfd3&"
import script from "./EditReceiverDelivery.vue?vue&type=script&lang=ts&"
export * from "./EditReceiverDelivery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports